<template>
  <v-card>
    <v-card-title class="headline">{{title}}</v-card-title>
    <v-card-text>
      <v-form  ref="form" v-model="valid" lazy-validation>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Opis" v-model="description"  :rules="[v=> !!v || 'Proszę podać opis.']"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-menu
                  v-model="open_date"
                  :nudge-right="40"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  ref="menudate"
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="selectedDatesDescription"
                      label="Przedział dat"
                      prepend-icon="fa-calendar-alt"
                      readonly
                      :rules="[v=> !!v || 'Proszę podać datę dnia wolnego.']"
                      clearable
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="selectedDates"
                    range
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="open_date = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menudate.save(selectedDates)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-checkbox v-model="godziny" label="Ograniczenie godzinowe"></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="godziny">
            <v-col cols="6">
              <TimePicker v-model="timeStart" text="Początek"></TimePicker>
            </v-col>
            <v-col cols="6">
              <TimePicker v-model="timeEnd" text="Koniec"></TimePicker>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save()" color="success">Zapisz</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="closeForm()" color="error">Zamknij</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {daysOffsService} from "@/services/daysoffs.service";
import swal from "sweetalert";
import dayjs from "dayjs";
import minMax  from 'dayjs/plugin/minMax';
import TimePicker from "@/components/shared/TimePicker.vue";
dayjs.extend(minMax);
export default {
  name: "DayOffEdit",
  props: ["edit"],
  components: {TimePicker},
  data() {
    return {
      title: '',
      description: null,
      selectedDates: null,
      open_date: false,
      valid: true,
      godziny: false,
      timeStart: null,
      timeEnd: null
    }
  },
  computed: {
    selectedDatesDescription() {
      if(this.selectedDates && this.selectedDates.length > 0)
      {
        return this.selectedDates.join(' ~ ')
      }
      return null
    }
  },
  methods:
  {
    save()
    {
      if(this.$refs.form.validate()) {

        if(this.godziny && (this.timeStart == null || this.timeEnd == null))
        {
          this.showError('Proszę wybrać przedział godzin')
          return
        }
        if(this.edit != null)
        {
          let arrrayOfDates = this.selectedDates.map(element => {
            return new dayjs(element);
          })
          let startDate = dayjs.min(arrrayOfDates).format('YYYY-MM-DD')
          let endDate = this.selectedDates.length > 1 ? dayjs.max(arrrayOfDates).format('YYYY-MM-DD') : this.selectedDates[0]
          if(this.godziny)
          {
            startDate += " "+this.timeStart
            endDate += " "+this.timeEnd
          }
          daysOffsService.update({
            id: this.edit.id,
            description: this.description,
            startTime: startDate,
            endTime: endDate,
            hours: this.godziny
          }).then(() => {
            this.$emit('close')
          }).catch((error) => {
            let err =error.response
            if(err.data != null && err.data.error && err.data.error.message)
            {
              this.showError(err.data.error.message)
            }
            else
            {
              this.showError("Nie zapisać dnia wolnego")
            }
          })
        }
        else
        {
          let arrrayOfDates = this.selectedDates.map(element => {
            return new dayjs(element);
          })
          let startDate = dayjs.min(arrrayOfDates).format('YYYY-MM-DD')
          let endDate = this.selectedDates.length > 1 ? dayjs.max(arrrayOfDates).format('YYYY-MM-DD') : this.selectedDates[0]
          if(this.godziny)
          {
            startDate += " "+this.timeStart
            endDate += " "+this.timeEnd
          }
          daysOffsService.create({
            description: this.description,
            startTime: startDate,
            endTime: endDate,
            hours: this.godziny
          }).then(() => {
            this.$emit('close')
          }).catch((error) => {
            let err =error.response
            if(err.data != null && err.data.error && err.data.error.message)
            {
              this.showError(err.data.error.message)
            }
            else
            {
              this.showError("Nie zapisać dnia wolnego")
            }
          })
        }
      }
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    closeForm()
    {
      this.$emit('close')
    }
  },
  watch: {
    edit: {
      immediate:true,
      handler(val)
      {
        if(val != null)
        {
          this.description = val.description
          let start = new dayjs(val.startTime)
          let end = new dayjs(val.endTime)
          if(start == end)
          {
            this.selectedDates = [start.format('YYYY-MM-DD')]
          }
          else
          {
            this.selectedDates = [start.format('YYYY-MM-DD'),end.format('YYYY-MM-DD'),]
          }
          this.godziny = val.hours
          this.timeStart = start.format('HH:nm:ss')
          this.timeEnd = end.format('HH:mm:ss')
        }
      }
    }
  }
}
</script>

<style scoped>

</style>